export const data = {
    '1_d': {
        name: '1 Общежитие',
        desc: 'Коридорного типа',
        img: '1_d.jpg',
    },
    '2_d': {
        name: '2 Общежитие',
        desc: 'Коридорного типа',
        img: '2_d.jpg',
    },
    '3_d': {
        name: '3 Общежитие',
        desc: 'Коридорного типа',
        img: '3_d.jpg',
    },
    '4_d': {
        name: '4 Общежитие',
        desc: 'Коридорного типа',
        img: '4_d.jpg',
    },
    '5_d': {
        name: '5 Общежитие',
        desc: 'Коридорного типа',
        img: '5_d.jpg',
    },
    '6_d': {
        name: '6 Общежитие',
        desc: 'Секционного типа',
        img: '6_d.jpg',
    },
    '7_d': {
        name: '7 Общежитие',
        desc: 'Секционного типа',
        img: '7_d.jpg',
    },
    '8_d': {
        name: '8 Общежитие',
        desc: 'Для аспирантов, преподавателей и сотрудников',
        img: '8_d.jpg',
    },
    '10_d': {
        name: '10 Общежитие',
        desc: 'Блочного типа',
        img: '10_d.jpg',
    },
    
    '1_s': {
        name: '1 Корпус',
        desc: `- Факультет прикладной математики и информатики\n- Административные подразделения\n- Институт дистанционного обучения\n- Факультет повышения квалификации`,
        img: '1_s.jpg',
    },

    '2_s': {
        name: '2 Корпус',
        desc: `- Факультет энергетики\n- Факультет мехатроники и автоматизации`,
        img: '2_s.jpg',
    },

    '3_s': {
        name: '3 Корпус',
        desc: `Факультет летательных аппаратов`,
        img: '3_s.jpg',
    },

    '4_s': {
        name: '4 Корпус',
        desc: `- Физико-технический факультет\n- Факультет радиотехники и электроники`,
        img: '4_s.jpg',
    },

    '5_s': {
        name: '5 Корпус',
        desc: `Механико-технологический факультет`,
        img: '5_s.jpg',
    },

    '6_s': {
        name: '6 Корпус',
        desc: `- Факультет бизнеса\n- Факультет гуманитарного образования\n- Институт дополнительного профессионального образования`,
        img: '6_s.jpg',
    },

    '7_s': {
        name: '7 Корпус',
        desc: `Факультет автоматики и вычислительной техники`,
        img: '7_s.jpg',
    },

    '8_s': {
        name: '8 Корпус',
        desc: `Институт социальных технологий и реабилитации`,
        img: '8_s.jpg',
    },

    '1_o': {
        name: 'Спортивная площадка',
        desc: '',
        img: '1_o.jpg',
    },

    '2_o': {
        name: 'Площадка для мини-футбола',
        desc: '',
        img: '2_o.jpg',
    },

    '3_o': {
        name: 'Дворец спорта с манежем',
        desc: '',
        img: '3_o.jpg',
    },

    '4_o': {
        name: 'Спортивный комплекс, бассейн',
        desc: '',
        img: '4_o.jpg',
    },

    '5_o': {
        name: 'Центр культуры',
        desc: '',
        img: '5_o.jpg',
    },

    '6_o': {
        name: 'Научная библиотека',
        desc: '',
        img: '6_o.jpg',
    },

    '7_o': {
        name: 'Типография, издательство',
        desc: '',
        img: '7_o.jpg',
    },

    '8_o': {
        name: 'Стартап-центр REACTOR',
        desc: '',
        img: '8_o.jpg'
    }
}

export const dormitories = ['1_d', '2_d', '3_d', '4_d', '5_d', '6_d', '7_d', '8_d', '10_d']
export const studies = ['1_s', '2_s', '3_s', '4_s', '5_s', '6_s', '7_s', '8_s']
export const other = ['1_o', '2_o', '3_o', '4_o', '5_o', '6_o', '7_o', '8_o']